// extracted by mini-css-extract-plugin
export var pillWrapper = "_ov-0";
export var showOverflow = "_ov-1";